import React from 'react';
import classes from './ButtonProceedMobile.scss';

const buttonProceedMobile = (props) => {
    return (
        <button className={[classes.ButtonProceedMobile, props.count === 0 ? classes.ButtonProceedMobileActive : null].join(' ')} {...props}>{props.children}</button>
    );
}

export default buttonProceedMobile;


// WEBPACK FOOTER //
// ./src/components/UI/Button/ButtonProceedMobile/ButtonProceedMobile.js